"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var param_1 = require("../conversions/param");
var sha3_1 = require("../libs/sha3");
var CryptoJS = require("crypto-js");
var blake = require("../libs/blake2b");
exports._hashChain = function (input) {
    return param_1._fromIn(exports.keccak(exports.blake2b(param_1._fromIn(input))));
};
exports.sha256 = function (input) {
    return param_1._fromWords(CryptoJS.SHA256(param_1._toWords(param_1._fromIn(input))));
};
exports.blake2b = function (input) {
    return blake.blake2b(param_1._fromIn(input), null, 32);
};
exports.keccak = function (input) {
    return param_1._fromIn(sha3_1.keccak256.array(param_1._fromIn(input)));
};
exports.hmacSHA256 = function (message, key) {
    return param_1._fromWords(CryptoJS.HmacSHA256(param_1._toWords(param_1._fromIn(message)), param_1._toWords(param_1._fromIn(key))));
};
//# sourceMappingURL=hashing.js.map